<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-header-menu-form-filter" v-bind:class="{'selected': isSelected}" v-if="dataModel.filters.formId.dataSource && dataModel.filters.formId.dataSource.length > 0">
      <el-dropdown 
        class="wy-header-manu-dropdown" 
        ref="formFilterWidget" 
        placement="top" 
        trigger="click"
        :hide-on-click="false" 
        @visible-change="handleChangeVisible">
        <span class="el-dropdown-title wy-disable-select">
          <div class="header-title">
            Form
          </div>
          <div class="container">
              <div class="el-dropdown-subtitle">
                <el-tooltip class="item" effect="dark" :content="currentForm.formName" placement="top">
                  <span> {{ currentForm.formName }}</span>
                </el-tooltip>
              </div>
              <i v-bind:class="{'el-icon-caret-right':!isSelected, 'angle-up':isSelected }" ></i>
          </div>
        </span>
        <el-dropdown-menu id="wyFormFilterPanel" class="wy-header-menu-panel wy-header-menu-form-filter-panel" slot="dropdown" :class="{'no-data-layout': !dataModel.hasFilter, 'no-date-range-layout': isDateRageHidden}">
          <!-- <transition name="bounce"> -->
            <div class="menu-panel" v-if="isShow">
              <!-- <div class="panel-column platform-panel" style="width: 55%;"> -->
                
                <div class="panel-content">
                  <div class="title-header" style="margin: 0px 0px;">Select form:</div>
                  <ul>
                    <el-radio v-model="selectedFormId" :label="item.formId" aria-modal="true" v-for="item in dataModel.filters.formId.dataSource" :key="item.formId" @change="handleSelectFormName(item)">
                      <span class="radio-label" @mouseover="handleMouseOver($event, item)" @mouseout="handleMouseOut">{{item.formName}}</span>
                    </el-radio>
                    <!-- <li v-for="item in dataModel.filters.formId.dataSource" :key="item.id" class="brand-name" :class="{'selected':item.id==selectedFormId}" @click="handleSelectBrandName(item)">{{item.name}}<span class="checkedIcon"></span></li> -->
                  </ul>
                  <a @click="closePopup()" class="cancel-btn prevent-select">Cancel</a>
                  <el-button class="wy-white-button form-filter-apply" ref="formApplyBtn" size="mini" @click="handleApply">{{ $t('button.apply') }}</el-button>
                </div>
              <!-- </div> -->
            </div>
          <!-- </transition> -->
        </el-dropdown-menu>
      </el-dropdown>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'wy-header-menu-form-filter',
  data() {
    return {
      isShow: false,
      isSelected: false,
      selectedFormId: null,
      currentForm: null,
      filterAppied: false
    }
  },
  computed: {   
    ...mapGetters(['authUser', 'dataModel']),

  isDateRageHidden() {
    let widget = this.$route.meta.headerMenuItems.find(el=>{
      return el.name == 'date-widget'
    })
    let isHidden = false;
    if((widget && widget.properties.hidden) || widget == undefined) {
      isHidden = true
    }
    return isHidden;
  }
  },

  methods: {
    ...mapActions(['applyFilterValue', 'undoFilterValue']),

    checkChanged() {
      this.hasChanged = this.dataModel.filters.formId.value != this.dataModel.filters.formId.previousValue;
    },

    handleSelectFormName(item) {
      this.selectedFormId = item.formId;
    },
    
    handleChangeVisible(isOpen) {
      if(isOpen){
        this.filterAppied = false;
        this.selectedFormId = this.dataModel.filters.formId.value;
        this.localSelectedFormId = this.selectedFormId;
        this.$refs.formFilterWidget.show();
        this.$refs.formFilterWidget.popperElm.style.transitionDelay = "0s";
        this.isShow = true;
        this.isSelected = true;
      }
      else {
        if(!this.filterAppied) {
          this.selectedFormId = this.localSelectedFormId;
        }
        this.$refs.formFilterWidget.hide();
        this.$refs.formFilterWidget.popperElm.style.transitionDelay = "0.1s";
        this.isSelected = false;
      }
      

      // fire global click overlay event to show the modal
      this.$root.$emit(`fire-app-clickOverlayModal-events`, {handleApply: this.handleApply, active: isOpen});
    },

    async handleApply() {
      this.dataModel.filters.formId.value = this.selectedFormId;
      if(await this.applyFilterValue(this.dataModel.filters.formId)) {
        this.$root.fireEvent({name: 'handleFilterChange', type: 'Global Filter: formFilter'});
        this.getFormName()
      }
      this.handleChangeVisible(false);
    },

    closePopup() {
      this.dataModel.filters.formId.value = this.dataModel.filters.formId.previousValue;
      this.handleChangeVisible(false);
    },
    clearAll() {
      this.dataModel.filters.formId.value = '';
    },

    getFormName(){
      this.dataModel.filters.formId.dataSource.forEach(form => {
        if(form.formId === this.selectedFormId) {
          this.currentForm = form
        }
      });
    },

    handleMouseOver(e, item) {
        e.stopPropagation();
        
        if(e.target.offsetWidth < e.target.scrollWidth) {
          const tooltipsEl = document.querySelector(".site-tooltips");
          if(tooltipsEl) {
            tooltipsEl.innerHTML = item.formName;
            tooltipsEl.style.display = 'block';
            tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width/2 + e.target.getBoundingClientRect().width/2}px`;
            tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height + 5}px`;
          }
        }
        else {
          e.preventDefault();
        }
      },

      handleMouseOut(e) {
        e.stopPropagation();

        const tooltipsEl = document.querySelector(".site-tooltips");
        if(tooltipsEl) {
          tooltipsEl.style.display = 'none';
        }
      }
  },
  created() {
    this.selectedFormId = this.dataModel.filters.formId.value;
    this.getFormName();
  }
}
</script>

<style lang="scss">
.wy-header-menu-form-filter {
  height: 74px;
  min-width: 175px;
  text-align: left;
  border-right: 1px var(--nav-top-right-border-color) solid;
  .container{
    float: left;
    width: 280px;
    // height: 81px;
    height: 32px;
    position: relative;
    // bottom: 47px;
    top: 0px;
    display: flex;
    /* padding-bottom: 24px; */
    align-items: flex-end;
    .el-dropdown-subtitle {
      display: inline-block;
      padding-right: 7px;
      max-width: 102px;
      text-overflow: ellipsis;
      text-align: left;
      left: 25px;
      bottom: 16px;
      position: relative;
      white-space: nowrap;
      overflow: hidden;
      font-size: 14px;
    }
  }
  .angle-up {
    background-image: var(--header-drop-down-arrow-up) !important;
    background-repeat: no-repeat;
    background-color: transparent;
    border: none;
    padding: 0;
    top: -8px;
    position: relative;
    height: 20px;
    left: 41px;
    background-size: 10px;
    background-position-x: 0px;
    width: 12px;
    float: right;
    margin-right: 4px;
  }
  
  .wy-header-menu-date-filter-picker {
    visibility: hidden !important;
    width: 1px !important;
    height: 10px !important;
  }
  .wy-header-manu-dropdown{
    margin: 0px 0px 0px 0px !important;
    padding: 14px 0px 0px 0px !important;
    border-radius: 5px !important;
    opacity: 1 !important;
    height: 74px;
    // top: -14px !important;
    .header-title {
      text-align: left;
      font-size: 14px;
      font-weight: 600;
      color: var(--nav-top-header-title);
      position: relative;
      top: -8px;
      left: 24px;
      width: 142px;
      margin-right: -14px;
    }
  }
  .wy-header-manu-dropdown.el-dropdown:hover {
    background-color: none !important;
  }
}
.wy-header-menu-form-filter.selected {
  background: var(--nav-top-background-color-selected) 0% 0% no-repeat padding-box !important;
  position: relative;
  z-index: 9999;
}
.wy-header-menu-form-filter-panel.no-data-layout {
  left: 301px !important;
}
.wy-header-menu-form-filter-panel.no-date-range-layout {
  // left: 302px !important;
  left: var(--site-top-menu-branding-panel-left) !important;
}
.wy-header-menu-form-filter-panel {
  width: min-content;
  border-radius: 0px;
  width: fit-content;
  // left: 612px!important;
  left: 301px !important;
  margin: 64px 0 0px 0 !important;
  overflow-x: hidden;
  overflow-y: hidden;

  .menu-panel {
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    -webkit-box-shadow: 0px 0px 6px #55596a40 !important;
    -webkit-box-shadow: 0px 0px 6px #55596a40 !important;
    box-shadow: 0px 0px 6px #55596a40 !important;
    background: var(--nav-top-menu-panel-background-color) 0% 0% no-repeat padding-box;
    padding: 0;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-block;
    width: calc(100vw - 400px);
    max-width: 990px;
    // height: 403px;
    margin-left: 0px;
    // min-width: 335px;
    position: relative;
    left: 0px;
    // border-top: 1px solid #C9D3DA;
    border-radius: 0px 0px 5px 5px;
  }
  @media (max-width: 1854px){
    .menu-panel {
      left: 0px !important;
    }
  }
  .wy-white-button.form-filter-apply {
    width: 104px;
    height: 30px;
    border-radius: 10px;
    border: 1px white solid;
    left: calc(100% - 169px);
    top: 21px;
    // background-color: #F4F6F8;
    padding-top: 6px;
    font-size: 14px;
    -webkit-box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    -webkit-box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    box-shadow: var(--top-menu-panel-global-filter-primary-btn-box-shadow) !important;
    background-color: var(--top-menu-panel-global-filter-primary-btn-background-color) !important;
    border: 1px white solid;
    border-radius: 5px;
    color: var(--top-menu-panel-global-filter-primary-btn-text-color);
    font-size: 14px;
    align-content: center;
    font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    position: relative;
    
    &:hover{
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: var(--top-menu-panel-global-filter-primary-btn-hover-background-color) !important;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-hover-text-color) !important;
      font-size: 14px;
      align-content: center;
      font-family: Helvetica Neue, Arial, Helvetica, sans-serif;
    }
    &:active {
      background-color: var(--top-menu-panel-global-filter-primary-btn-pressed-background-color) !important;
    }
    &:focus {
      border: 1px var(--top-menu-panel-global-filter-primary-btn-hover-border-color) solid !important;
      background-color: unset;
      border-radius: 5px;
      color: var(--top-menu-panel-global-filter-primary-btn-text-color) !important;
    }
    span {
      position: relative;
      top: 1px;
    }
  }

  .panel-column {
    display: inline-grid;
    width: fit-content;
    padding: 0px 15px 2px 15px;
  }

  .el-dropdown-menu__item {
    line-height: 29px;
  }
  .panel-content {
    padding-bottom: 42px;
    padding-top: 5px;
    width: 100%;
    box-shadow: 0px -4px 10px rgba(74, 74, 74, 0.25);
    // height: 294px;
    // border-radius: 15px;
    // border-bottom: 1px #323232 solid;
  }
  .el-radio__inner:hover {
    // border-color: white !important;
    // background: #353E43 !important;
    background: var(--top-menu-panel-global-filter-radio-button-checked-background-color);
  }
  .el-radio__inner {
    -webkit-box-shadow: unset !important;
    box-shadow: unset !important;
  }
  
  
  .cancel-btn{
    top: 23px;
    left: 28px;
    position: relative;
    font-size: 14px;
    color: var(--top-menu-panel-global-filter-cancel-btn-color);
    cursor: pointer;
  }
  .title-header {
    font-weight: var(--top-menu-panel-global-filter-header-text-font-weight);
    font-size: var(--top-menu-panel-global-filter-header-text-font-size);
    color: var(--top-menu-panel-global-filter-header-text-color);
    padding: 12px 22px;
    margin-bottom: 8px !important;
  }
  .el-radio__label {
    color: var(--top-menu-panel-brand-header-text) !important;
    font-weight: normal !important;
  }

  .el-radio:hover {
    // background: #353E43;
    background: var(--top-menu-panel-calendar-text-hover-background-color);
    border-radius: 5px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: var(--top-menu-panel-global-filter-radio-button-border-color) ;
  }
  .el-radio.is-checked{
    background: var(--top-menu-panel-calendar-text-selected-background-color);
    border-radius: 5px;
  }
  .el-radio__inner{
    width:10px;
    height: 10px;
    background: var(--top-menu-panel-global-filter-radio-button-background-color) !important;
  }
  .el-radio__inner::after{
    width: 5px !important;
    height: 5px !important;
    border-radius: 50%;
    background-color: var(--top-menu-panel-global-filter-radio-button-color);
  }
  // --top-menu-panel-global-filter-radio-button-background-color: #FFF;
  // --top-menu-panel-global-filter-radio-button-checked-background-color: #FFF;
  // --top-menu-panel-global-filter-radio-button-border-color: #444D54;
  // --top-menu-panel-global-filter-radio-button-color: #444D54;
  .el-radio {
    display: block;
    margin: 7px 0px;
    padding: 9px 0px 11px 15px;
    position: relative;
    left: 19px;
    height: 12px;
    // width: 259px;
    max-width: 260px;
    // height: 12px;
    flex: 1 1 240px;
    margin-bottom: 13px;
    margin-right: 54px;

    .radio-label {
      display: inline-block; 
      width: 234px;
      white-space: nowrap;
      overflow: hidden !important;
      text-overflow: ellipsis;
      vertical-align:bottom;
      height: 16px;
    }
  }
  
  ul {
    padding-left: 0px;
    // height: 270px;
    display: flex;
    // flex-direction: column;
    flex-wrap: wrap;
    border-bottom: 1px var(--top-menu-panel-global-filter-divider-color) solid;
    max-height: 400px;
    // height: calc(100vh - 518px);
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 10px;

    &::-webkit-scrollbar {
      width: 20px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 2px solid transparent;
      border-top: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
    &::-webkit-scrollbar-track {
      background: var(--site-top-menu-branding-panel-scroll-bar-track-background-color);
      border-top: 0px solid #CAD2DA;
    }
    &::-webkit-scrollbar:vertical {
      width: 14px;
    }
    &::-webkit-scrollbar-thumb:vertical {
      border-radius: 160px;
      border: 2px solid transparent;
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      background-clip: content-box;
      background-color: #CAD2DA;
    }
  }
  .form-filter-name.selected {
    box-sizing: border-box;
    border-radius: 3px;
    width: 243px;
    .checkedIcon{
      background-image: url('../../assets/icons/icon_white_check.svg');
      background-repeat: no-repeat;
      background-size: 15px 15px;
      background-position-x: 3px;
      background-position-y: 8px;
      width: 20px;
      height: 30px;
      vertical-align: middle;
      float: right;
    }
  }
  .form-filter-name {
    color: #F4F6F8;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    border: 0.5px transparent solid;
    padding: 0px 9px;
    list-style: none;
    margin: 13px 10px;
    margin: 5px 10px;
    width: 221px;
    line-height: 30px;
  }
  .form-filter-name:focus, .form-filter-name:hover {
    background-color: rgba(229, 234, 242, 0.09);
    .checkedIcon{
      color: #EBF4FD;
    }
    color: #F4F6F8;
  }
}
</style>